import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import { IHireEmployeeTransactionRecordDto } from "../../../dtos/transactions/IHireEmployeeTransactionRecordDto";

interface IProps {
  items: IHireEmployeeTransactionRecordDto[];
}

export const HireEmployeeTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column
            dataField="tableMovementType"
            dataType="string"
            caption={"Movement Type"}
            width={100}
            cellRender={(column: any) => {
              return <MovementTypeColumn column={column} />;
            }}
          />

          <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"} sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField={"personId"} dataType={"string"} caption={"Person ID"} />
          <Column width={150} dataField={"documentId"} dataType={"string"} caption={"Document ID"} />
          <Column width={150} dataField={"employeeId"} dataType={"string"} caption={"Employee ID"} />
          <Column width={150} dataField={"companyId"} dataType={"string"} caption={"Company ID"} />
          <Column width={150} dataField={"hireDate"} dataType={"datetime"} caption={"Hire Date"} />
          <Column width={150} dataField={"workScheduleId"} dataType={"string"} caption={"Work Schedule ID"} />
          <Column width={150} dataField={"salary"} dataType={"number"} caption={"Salary"} />
          <Column width={150} dataField={"divisionId"} dataType={"string"} caption={"Division"} />
          <Column width={150} dataField={"contractNumber"} dataType={"string"} caption={"Contract Number"} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
